<template>
  <div class="incremental-onboarding-view-container">
    <div
      class="onboarding-view no-sidebar"
    >
      <div class="top-fixed">
        <IncrementalOnboardingHeader
          :dismiss="() => showDismissConfirmation = true" :current-step="0"
          :add-bank-account-view="true"
        />
      </div>
      <div class="s-flex s-gap-8 s-p-6 s-py-0">
        <div class="s-p-4 s-fixed s-top-4" style="width: 256px; margin-top: 10px;">
          <div>
            <nav class="s-bg-white s-rounded-md progress">
              <ul class="s-space-y-2 s-list-none s-text-left">
                <li
                  class="s-flex s-items-center s-gap-2 s-text-primary-600"
                >
                  <span
                    class="s-flex s-items-center s-justify-center"
                    style="width: 24px"
                  >
                    <span
                      style="width: 20px; height: 20px"
                      class="current-outer-circle s-bg-gray-200 s-flex s-justify-center s-items-center s-rounded-full"
                    >
                      <span
                        style="width: 10px; height: 10px"
                        class="current-inner-circle s-rounded-full"
                      ></span>
                    </span>
                  </span>
                  <span>Bank Account</span>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <!-- Main Content -->
        <div class="s-flex-1 s-p-6" style="margin-left: 350px; margin-top:10px; padding-bottom: 300px; max-width: 600px">
          <incremental-onboarding-bank-account-for-payout :add-bank-account="true" />
        </div>
      </div>
      <s-modal
        :control-variable="showDismissConfirmation"
        :primary-action="{
          label: $t('global.action.confirm'),
          action: dismiss
        }"
        :secondary-action="{
          label: $t('global.action.cancel'),
          action: () => showDismissConfirmation = false
        }"
        :heading="$t('dismissConfirm.title')"
        size="small"
        action-variant="danger"
        :description="$t('dismissConfirm.description')"
      >
        <template #body>
          <div class="s-text-left">
            {{ $t('dismissConfirm.description') }}
          </div>
        </template>
      </s-modal>
      <div class="footer-fixed s-flex s-flex-col s-p-3">
        <div class="i title-description s-leading-snug s-text-neutral-600 s-mb-2">
          <i>{{ $t('onboarding.info') }}</i>
        </div>
        <i18n path="onboarding.assistance" tag="div" class="title-description s-leading-snug">
          <template #faqPage>
            <c-link
              href="https://www.chargebee.com/docs/2.0/cb_payments_faq.html"
              target="_blank"
            >
              {{ $t('onboarding.faqPage') }}
            </c-link>
          </template>
          <template #documentationPage>
            <c-link
              href="https://www.chargebee.com/docs/2.0/cb_payments.html"
              target="_blank"
            >
              {{ $t('onboarding.documentationPage') }}
            </c-link>
          </template>
        </i18n>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {OnboardingStatus, OnboardingStep} from '@/app/utils/common/constants';
import {navigateTo} from '@/router';
import {RouteConstants} from '@/router/routeConstants';
import IncrementalOnboardingBankAccountForPayout
  from "@/components/incremental-onboarding/IncrementalOnboardingBankAccountForPayout.vue";
import "@/app/assets/style/incremental-onboarding-form.scss";
import IncrementalOnboardingHeader from "@/components/onboarding/IncrementalOnboardingHeader.vue";

export default {
  name: "IncrementalOnboardingAddBankAccount",
  components: {
    IncrementalOnboardingHeader,
    IncrementalOnboardingBankAccountForPayout
  },
  data: function () {
    return {
      showDismissConfirmation: false
    };
  },
  computed: {
    ...mapGetters('app', ['isAdminMode', 'getMerchantId', 'getSessionPayfac',
      'getDraftMerchantId', 'getMerchantName', 'getCbSiteName']),
    ...mapGetters('merchantPayfacDetails', ['getOnboardingStatus', 'getOnboardingStep']),
  },
  mounted() {
    let onboardingStatus = this.getOnboardingStatus(this.getSessionPayfac);
    if (
        [
          OnboardingStatus.PROVISIONING,
          OnboardingStatus.REJECTED
        ].includes(onboardingStatus)) {
      navigateTo(RouteConstants.SETUP_PROGRESS)
      return;
    }

    let onboardingStep = this.getOnboardingStep(this.getSessionPayfac);

    if (onboardingStatus === OnboardingStatus.APPROVED && onboardingStep !== OnboardingStep.SUBMITTED_SKIPPED_BANK_ACCOUNT) {
      navigateTo(RouteConstants.DASHBOARD)
    }
    this.validateAllFields();
  },
  methods: {
    dismiss() {
      navigateTo(RouteConstants.SETUP_PROGRESS)
    },
    ...mapActions('bankAccountForPayouts', [
      'validateAllFields'
    ]),
    ...mapActions('app', ['updateAppState'])
  },
}
</script>